import React from 'react';

import {useTranslation} from 'react-i18next';

import {NavBar, NavLink} from 'components/ui-kit/NavBar';
import {ROUTE} from 'core/routes';

export const GridsNavigation = () => {
    const {t} = useTranslation();
    return (
        <NavBar style={{marginLeft: 'auto'}}>
            <NavLink exact to={ROUTE.PRODUCTS_CONSUMER_GRID}>
                {t('pages.products.tabs.consumer')}
            </NavLink>
            <NavLink exact to={ROUTE.PRODUCTS_TRANSPORT_GRID}>
                {t('pages.products.tabs.transport')}
            </NavLink>
            <NavLink exact to={ROUTE.PRODUCTS_CUSTOMS_GRID}>
                {t('pages.products.tabs.customs')}
            </NavLink>
        </NavBar>
    );
};
